import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { DesignPackageServices } from "@/services/bedrock/DesignPackageServices";
import { DesignPackageListParams } from "@/services/bedrock/dtos/DesignPackage";
import { designKeys } from "@/services/bedrock/queryKeys";

export interface UseDesignPackagesOptions {
  enabled?: boolean;
  staleTime?: number;
}

/** Paged package list for the inspiration strip, the template gallery, and counts. */
export function useDesignPackages(params: DesignPackageListParams, opts: UseDesignPackagesOptions = {}) {
  return useQuery({
    queryKey: designKeys.list(params),
    queryFn: () => DesignPackageServices.list(params),
    placeholderData: keepPreviousData,
    staleTime: opts.staleTime ?? 30_000,
    enabled: opts.enabled ?? true,
  });
}
